import axios from 'axios'

export const vtexProductApi = {

    GetProductComplete({ skuid } = {}) {
        return axios
            .get('https://www.lavillecasa.com.br/api/catalog_system/pub/products/search?fq=skuId:' + skuid)
            .then((response) => {
                var prods = response.data;
                if (prods.length > 0) {
                    prods.forEach((item) => {
                        var prod = {};
                        if (item.items != null && item.items.length > 0) {
                            var sku = item.items[0];
                            prod.description = sku.nameComplete;
                            prod.skuid = sku.itemId;
                            if (sku.sellers != null && sku.sellers.length > 0) {
                                var seller = sku.sellers[0];
                                if (seller.commertialOffer != null) {
                                    var hasListPrice = seller.commertialOffer.ListPrice > seller.commertialOffer.Price;
                                    prod.price = "R$ " + seller.commertialOffer.Price.toFixed(2);
                                    prod.listPrice = hasListPrice ? ("R$ " + seller.commertialOffer.ListPrice.toFixed(2)) : "";
                                }
                            }
                            if (sku.images != null && sku.images.length > 0)
                            {
                                prod.imageUrl = sku.images[0].imageUrl;
                            }
                            prod.reference = item.productReference;
                            return prod;
                        }
                    });
                }
                throw new Error()
            })
    },


}
